export const XOOG_PATTERN: RegExp = /X009:(.*?):X009/g;
export const XOOG_SUBJECT_RE: RegExp = /\(Secured by(.*?)@Xoog\)/;
export const EMAIL_RE: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const DECRYPT_WINDOW_READY: string = "parentReady";
export const DECRYPT_PAGE: string = "showmessage.html";
export const CHAR_LIMIT: number = 10000;
